import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AvatarType } from '@tencent/wemeet-websdk-next';
import { getOpenId } from '@utils/wemmet';
// import { reportUserLoginFail, reportUserLoginSuceess, setAegisUin } from 'src/report/aegis';

import type { AppState } from '../index';
import { loginInVoov, xmppLogin } from './authentication.trunk';

export enum VoovLoginStateEnum {
  idle = 'idle', // 初始状态
  logging = 'logging', // 正在登录
  succeeded = 'succeeded', // 成功登录
  failed = 'failed', // 失败
}

export enum XmppLoginStateEnum {
  idle = 'idle', // 初始状态
  logging = 'logging', // 正在登录
  succeeded = 'succeeded', // 成功登录
  failed = 'failed', // 失败
}

// slice state 类型定义
interface AuthenticationState {
  voovAuthInfo?: VoovAuthInfo;
  isGuest: boolean;
  fixVideoSwitch: boolean;

  voovLoginState: VoovLoginStateEnum;
  xmppLoginState: 'idle' | 'logging' | 'succeeded' | 'failed';
}

export interface VoovAuthInfo {
  // FIXME: 真的是中文名称吗？
  chineseName: string;
  username: string;
  nickname: string;

  userid: string;
  userSign: string;

  openId: string;

  avatar: string;
  avatarType: AvatarType;
  avatarToken: string;

  appid: string;
  deviceId?: string;
  user_district?: any;
}

// 初始状态
const initialState: AuthenticationState = {
  voovAuthInfo: undefined,
  isGuest: false,
  fixVideoSwitch: false,
  voovLoginState: VoovLoginStateEnum.idle,
  xmppLoginState: 'idle',
};

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setVoovLoginState: (state, action: PayloadAction<AuthenticationState['voovLoginState']>) => {
      state.voovLoginState = action.payload;
    },
    setXmppLoginState: (state, action) => {
      state.xmppLoginState = action.payload;
    },
  },
  extraReducers: (builder) => {
    /**
     *
     * action 的类型 {
     *  meta: {}
     *  payload: loginInVoov 返回的数据
     *  type: authentication/loginInVooV/fulfilled
     * }
     */
    builder.addCase(loginInVoov.fulfilled, (state, action) => {
      if (action.payload) {
        const data = action.payload;

        // const openId = getOpenId('5', data.userid, data.app_id);

        state.voovLoginState = VoovLoginStateEnum.succeeded;
        state.fixVideoSwitch = data?.fixVideoSwitch ?? false;
        state.voovAuthInfo = {
          chineseName: data?.name ?? '',
          username: data?.userid ?? '',
          nickname: data.nick_name ?? '',

          userid: data?.userid ?? '',
          userSign: data.wemeet_sign ?? '',

          openId: getOpenId('5', data?.userid ?? '', data?.app_id ?? ''),

          avatar: data?.avatar ?? '',
          avatarToken: data?.avatar_token ?? '',
          avatarType: data.avatar_type as AvatarType,

          appid: data?.app_id ?? '',
          deviceId: data?.deviceId ?? '',
          user_district: data?.user_district ?? '0',
        };
      }
    });
    builder.addCase(xmppLogin.fulfilled, (state, action) => {
      console.log('action.payload:', action.payload);
      state.xmppLoginState = action.payload;
    });

    // builder.addCase(checklawful.fulfilled, (state, action) => {
    //   const data = action.payload;

    //   if (data.need_check_lawful) {
    //     state.
    //   }
    // })
  },
});

export const { setXmppLoginState, setVoovLoginState } = authenticationSlice.actions;

export const getVoovLoginState = (state: AppState) => state.authentication.voovLoginState;
export const getVoovAuthInfo = (state: AppState) => state.authentication.voovAuthInfo;
export const getFixVideoSwitch = (state: AppState) => state.authentication.fixVideoSwitch;

export const getXMPPLoginState = (state: AppState) => state.authentication.xmppLoginState;

export default authenticationSlice.reducer;
